import EDC from '@/components/games/shared/globals';
import Preloader from './preloader';
import Main from './main';
/**
 *
 */
EDC.Games.GameTypePicker.Scenes.Boot = function () {};
/**
 *
 */
EDC.Games.GameTypePicker.Scenes.Boot.prototype.create = function () {
  this.scene.add('GameTypePicker-Preloader', Preloader);
  this.scene.add('GameTypePicker-Main', Main);
  this.scene.start('GameTypePicker-Preloader');
};

export default EDC.Games.GameTypePicker.Scenes.Boot;
